export default __webpack_public_path__ + "4facd54028a16681bb381297ee6569f3.svg";